module.exports = __webpack_public_path__ + "static/media/nb3.486dc3cf.jpg";